module.exports = __webpack_public_path__ + "static/media/instagram.0634a5ba.png";